
import React from "react";

interface CustomAddIconProps {
  className?: string;
  size?: number;
  variant?: "blue" | "gray" | "purple";
}

const CustomAddIcon: React.FC<CustomAddIconProps> = ({ 
  className = "", 
  size = 24,
  variant = "gray"
}) => {
  // Define colors based on variant
  const circleColor = 
    variant === "blue" ? "#0073FF" : 
    variant === "purple" ? "#9b87f5" : 
    "#C8C8C9"; // Light grey for normal state
    
  const crossColor = variant === "gray" ? "#C8C8C9" : "#FFFFFF";
  
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Circle background */}
      <circle 
        cx="12" 
        cy="12" 
        r="10" 
        fill={variant === "gray" ? "transparent" : circleColor} 
        stroke={variant === "gray" ? circleColor : "transparent"}
        strokeWidth="1.5"
      />
      {/* Horizontal line */}
      <path 
        d="M8 12H16" 
        stroke={crossColor} 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
      {/* Vertical line */}
      <path 
        d="M12 8V16" 
        stroke={crossColor} 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CustomAddIcon;
